import { g } from "../../Gamification/components/shared/tokens";

const styles = {
  card: {
    background: g.cardBg,
    border: `1px solid ${g.border}`,
    borderRadius: g.radiusLg,
    p: { xs: "16px", md: "22px" },
    display: "flex",
    flexDirection: "column",
  },
};

export default styles;
